var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4994 4.38916H4.16602C3.03268 4.38916 2.16602 5.25583 2.16602 6.38916V14.3892C2.16602 15.5225 3.03268 16.3892 4.16602 16.3892H13.4994C14.6327 16.3892 15.4994 15.5225 15.4994 14.3892V6.38916C15.4994 5.25583 14.6327 4.38916 13.4994 4.38916ZM13.4994 5.72249C13.6327 5.72249 13.6994 5.78916 13.766 5.78916L8.83268 10.7892L3.83268 5.78916C3.96602 5.78916 4.03268 5.72249 4.16602 5.72249H13.4994ZM14.166 14.3892C14.166 14.7892 13.8994 15.0558 13.4994 15.0558H4.16602C3.76602 15.0558 3.49935 14.7892 3.49935 14.3892V7.32249L8.36602 12.1892C8.63268 12.4558 9.03268 12.4558 9.29935 12.1892L14.166 7.32249V14.3892Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4ef0ed97e542ae661ecf377d799b88dd.svg";
export { ForwardRef as ReactComponent };